export const ApplicationConstant = {
    ApplicationID : 115,
    clientId : 9,
    DEFAULT_DATE_FORMAT: 'DD/MM/Y'
};
